export default "__VITE_ASSET__CP9kDrF9__"